<div class="row">
  <div class="col-12 mt-2 mt-md-5 line line-before"></div>
</div>
